"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var s = require("./CashierPaymentsMethod.scss");
var CreditCard_1 = require("./../../components/CreditCard");
var Loader_1 = require("./../../components/Loader");
var Offline_1 = require("./../../components/Offline");
var Wallet_1 = require("./../../components/Wallet");
var PaymentDetails_1 = require("./../PaymentDetails");
var PaymentsStore_1 = require("./../../data/PaymentsStore");
var CashierPaymentsMethod = (function (_super) {
    __extends(CashierPaymentsMethod, _super);
    function CashierPaymentsMethod() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isComponentMounted = false;
        _this.state = {
            isLoadingLanguage: true,
            installments: null,
        };
        _this.safeSetState = function (state) {
            if (_this.isComponentMounted) {
                _this.setState(state);
            }
        };
        _this.handleCountryChange = function (country) { return __awaiter(_this, void 0, void 0, function () {
            var paymentMethodData, installments;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(country && this.props.countryCode !== country.value)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.paymentsSDK.fetchPaymentMethodSettings(this.props.paymentMethod.paymentMethod, { orderId: this.props.orderId }, 'https://cashier-services.wix.com')];
                    case 1:
                        paymentMethodData = _a.sent();
                        if (paymentMethodData && paymentMethodData.paymentMethod) {
                            installments = paymentMethodData.paymentMethod.installments;
                            this.setState({ installments: installments });
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.isPaymentsDetailsEnabled = function () {
            // TODO in future here should be always true
            return _this.props.paymentDetails;
        };
        _this.renderPaymentMethod = function (name, node) {
            return PaymentsStore_1.default.renderPaymentMethod(name, node);
        };
        _this.renderPaymentMethodComponentByType = function () {
            if (_this.state.isLoadingLanguage || !PaymentsStore_1.default) {
                return React.createElement(Loader_1.default, null);
            }
            var _a = _this.props.paymentMethod, paymentMethod = _a.paymentMethod, name = _a.name, additionalInfo = _a.additionalInfo;
            switch (paymentMethod) {
                case 'creditCard': {
                    var installmentsFromMandatoryFields = _this.state.installments;
                    var info = Object.assign({}, additionalInfo, { installments: (additionalInfo && additionalInfo.installments) || installmentsFromMandatoryFields });
                    return (React.createElement(CreditCard_1.default, { setInstallments: _this.props.paymentsSDK.setInstallments, info: info, renderPaymentMethod: _this.renderPaymentMethod }));
                }
                case 'offline': {
                    return (React.createElement(Offline_1.default, { info: additionalInfo }));
                }
                default: {
                    return (React.createElement(Wallet_1.default, { payButtonLabel: _this.props.payButtonLabel, paymentMethodName: paymentMethod, paymentMethodLabel: name }));
                }
            }
        };
        return _this;
    }
    CashierPaymentsMethod.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isComponentMounted = true;
                        return [4 /*yield*/, PaymentsStore_1.default.initPayments({
                                locale: this.props.locale,
                                paymentsSDK: this.props.paymentsSDK,
                                paymentMethod: this.props.paymentMethod,
                                orderId: this.props.orderId,
                            })];
                    case 1:
                        _a.sent();
                        this.safeSetState({ isLoadingLanguage: false });
                        return [2 /*return*/];
                }
            });
        });
    };
    CashierPaymentsMethod.prototype.componentWillUnmount = function () {
        this.isComponentMounted = false;
    };
    CashierPaymentsMethod.prototype.render = function () {
        return (React.createElement("div", { "data-hook": "cashier-payments-method", className: s.root },
            this.renderPaymentMethodComponentByType(),
            this.isPaymentsDetailsEnabled()
                ? (React.createElement(PaymentDetails_1.default, { countryCode: this.props.countryCode, locale: this.props.locale, externalPayButton: this.props.externalPayButton, isMobileApplication: this.props.isMobileApplication, paymentsSDK: this.props.paymentsSDK, paymentMethod: this.props.paymentMethod, orderId: this.props.orderId, onCountryChange: this.handleCountryChange, isMandatoryFieldsEnabled: this.props.isMandatoryFieldsEnabled }))
                : null));
    };
    return CashierPaymentsMethod;
}(React.Component));
exports.default = CashierPaymentsMethod;
//# sourceMappingURL=CashierPaymentsMethod.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/containers/CashierPaymentsMethod/CashierPaymentsMethod.js
// module id = 146
// module chunks = 0 1